import { useRouter } from 'next/navigation';

import CpInfoCard from '@/components/cp/cpInfoCard/cpInfoCard';
import MoreOption from '@/features/moreOption/moreOption';
import { useBaseStore } from '@/store/base';
import { useNotifyStore } from '@/store/notify';
import { CpInfoType } from '@/types/cpType';

import LeftIcon from './img/left.svg';
import ShareIcon from './img/share.svg';

import style from './cpInfoHeader.module.scss';

function CpInfoHeader({
    cpInfoData,
    backHistory
}: {
    cpInfoData: CpInfoType;
    backHistory?: boolean;
}) {
    const setSnackMessage = useNotifyStore.use.setSnackMessage();
    const router = useRouter();
    const installPWA = useBaseStore.use.installPWA();
    const baseUrl =
        useBaseStore.getState().envParams === 'prod'
            ? process.env.NEXT_PUBLIC_BASE_WEBSITE_URL_PROD
            : process.env.NEXT_PUBLIC_BASE_WEBSITE_URL_DEV;

    const handleBack = () => {
        if (backHistory) {
            router.back();
        } else {
            router.push('/');
        }
        setTimeout(() => {
            installPWA();
        }, 2000);
    };

    const shareSite = async () => {
        if (typeof navigator.share !== 'undefined') {
            await navigator
                .share({
                    title: 'WHyWHy',
                    url: `${baseUrl}${location.pathname}`
                })
                .then(() => {
                    setSnackMessage({
                        message: '分享成功！'
                    });
                })
                .catch(async error => {
                    await navigator.clipboard.writeText(`${baseUrl}${location.pathname}`);
                    console.error(error);
                });
        } else {
            await navigator.clipboard.writeText(`${baseUrl}${location.pathname}`);
            setSnackMessage({
                message: '已複製分享連結！'
            });
        }

        return null;
    };

    const handleShareBtn = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        shareSite();
    };

    return (
        <header className={style.cpInfoHeader}>
            <div className={style.leftBar}>
                <LeftIcon className={style.backBtn} onClick={() => handleBack()} />
                {cpInfoData?.avatar && (
                    <CpInfoCard
                        className={style.headerCpInfo}
                        userName={cpInfoData.nickname}
                        userId={cpInfoData.user_id}
                        src={cpInfoData.avatar}
                        tag={cpInfoData.label}
                        subText={`@${cpInfoData.account}`}
                        linkToCpPage={false}
                        lightStyle
                    />
                )}
            </div>
            <ShareIcon
                className={style.shareBtn}
                onClick={(event: React.MouseEvent<HTMLElement>) => handleShareBtn(event)}
            />
            <MoreOption className={style.option} />
        </header>
    );
}

export default CpInfoHeader;
